<template>
  <div class="address">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="active"><a href="#">配送地址</a></li>
        </ul>
      </nav>
    </div>
    <el-form :model="addressItem" ref="ruleForm" :rules="addressRule" label-width="130px" class="userForm">
      <el-form-item label="收货人姓名" prop="name">
        <el-input v-model="addressItem.name" placeholder="请输入收货人姓名"></el-input>
      </el-form-item>
      <el-form-item label="所在地区" prop="region" class="addressxx">
        <el-select v-model="addressItem.province" placeholder="请选择" @change="queryCities">
          <el-option
            v-for="item in provinces"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>&nbsp;-&nbsp;<el-select v-model="addressItem.city" @change="queryAreas" placeholder="请选择">
          <el-option
            v-for="item in cities"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>&nbsp;-&nbsp;<el-select v-model="addressItem.area" placeholder="请选择">
          <el-option
            v-for="item in areas"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="街道地址" prop="address">
        <el-input v-model="addressItem.address" placeholder="请输入街道地址"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="mobile">
        <el-input v-model="addressItem.mobile" placeholder="请输入手机号码"></el-input>
      </el-form-item>
      <el-form-item label="邮编号码" prop="zip">
        <el-input v-model="addressItem.zip" placeholder="请输入邮编号码"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="danger" plain class="btn-reg" @click="submitForm('addressItem')">确认地址</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      class="addresslist">
      <el-table-column
        label="收货人"
        >
        <template slot-scope="scope">
          <a href="#">{{ scope.row.name }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="address_detail"
        label="所在区域"
        >
      </el-table-column>
      <el-table-column
        prop="address"
        label="街道地址"
        align="center"
        width="205px"
        >
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号码"
        align="center"
        >
      </el-table-column>
      <el-table-column
        prop="zip"
        label="邮编"
        align="center"
        >
      </el-table-column>
      <el-table-column
        label="设置默认"
        align="center"
        >
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.isdefault" @change="defaultAddress(scope.row)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="90px"
        >
        <template slot-scope="scope">
          <a href="javascript:void(0);" @click="update(scope.row)">修改</a> |
          <a href="javascript:void(0);" @click="del(scope.row.id)">删除</a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'message',
  components: {
  },
  data () {
    var regionValidator = (rule, value, callback) => {
      if (this.addressItem.provice === '' || this.addressItem.city === '' || this.addressItem.area === '') {
        callback(new Error('请选择所在地区'))
      } else {
        callback()
      }
    }
    return {
      currentPage: 1,
      addressItem: {
        id: '',
        name: '',
        address: '',
        zip: '',
        mobile: '',
        province: '',
        city: '',
        area: ''
      },
      checked: false,
      tableData: [],
      provinces: [],
      cities: [],
      areas: [],
      addressRule: {
        name: [
          { required: true, message: '请输入收货人姓名', trigger: 'blur' },
          { pattern: /^[\u0391-\uFFE5]+$/, message: '请输入中文' }
        ],
        region: [
          { validator: regionValidator }
        ],
        address: [
          { required: true, message: '请输入街道地址', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
        ],
        zip: [
          { required: true, message: '请输入邮编号码', trigger: 'blur' },
          { min: 0, max: 6, message: '长度不能超过6个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadAreas()
    this.selectAddressList()
  },
  methods: {
    loadAreas() {
      this.sapost('/dmc/address/loadAreas', '', r => {
        let { retMsg, retCode, provinces } = r.data
        if (retCode === '0') {
          this.provinces = provinces
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    selectAddressList() {
      this.sapost('/dmc/address/addressList', '', r => {
        let { retMsg, retCode, addressList } = r.data
        if (retCode === '0') {
          addressList.forEach(item => {
            if (item.isdefault === 'y') {
              item.isdefault = true
            } else {
              item.isdefault = false
            }
          })
          this.tableData = addressList
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    queryCities (item) {
      this.addressItem.city = null
      this.addressItem.area = null
      let queryParam = {provinceCode: item}
      this.sapost('/dmc/address/selectCitysByProvinceCode', queryParam, r => {
        this.cities = r.data
      })
    },
    queryAreas (item) {
      this.addressItem.area = null
      this.areas = []
      let city = this.cities.find(city => city.code === item)
      this.areas = city.children
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let address = JSON.stringify(this.addressItem)
          this.$http({
            method: 'post',
            url: '/dmc/address/addressManage',
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: address
          }).then(r => {
            let { retMsg, retCode } = r.data
            if (retCode === '0') {
              this.$message.success(retMsg)
              this.$refs.ruleForm.resetFields()
              this.addressItem.province = null
              this.addressItem.city = null
              this.addressItem.area = null
              this.selectAddressList()
            } else {
              if (retMsg === '用户未登录！') {
                eventBus.$emit('logout')
              }
              this.$message.warning(retMsg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    del(id) {
      let aid = {id: id}
      this.sapost('/dmc/address/deleteAddress', aid, r => {
        let { retMsg, retCode } = r.data
        if (retCode === '0') {
          this.$message.success(retMsg)
          this.selectAddressList()
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    update(row) {
      let queryParam = {provinceCode: row.province}
      this.sapost('/dmc/address/selectCitysByProvinceCode', queryParam, r => {
        this.cities = r.data
        let city = this.cities.find(city => city.code === row.city)
        this.areas = city.children
        Object.keys(this.addressItem).map(key => {
          this.addressItem[key] = row[key]
        })
      })
    },
    defaultAddress(row) {
      this.tableData.forEach(item => {
        if (item.id !== row.id) {
          item.isdefault = false
        } else {
          let queryParam = {id: row.id}
          this.sapost('/dmc/address/setAddressDefault', queryParam, r => {
            let { retMsg, retCode } = r.data
            if (retCode === '0') {
              this.$message.success(retMsg)
            } else {
              if (retMsg === '用户未登录！') {
                eventBus.$emit('logout')
              }
              this.$message.warning(retMsg)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
.address{
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  .t-nav {
    nav{
      border-bottom: 2px solid #ddd;
      ul {
        margin-right: 150px;
        height: 60px;
        color: #b4b8bb;
        li{
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a{
            color:#b4b8bb;
          }
        }
        li.active,li:hover {
          border-bottom: 2px solid #f01400;
          a{
            color:#f01400;
          }
        }
      }
    }
  }
  .r-title{
    float: right;
    height: 60px;
    line-height: 60px;
    span{
      color: #f01400;
    }
  }
  .pages{
    text-align: right;
    padding-top: 15px;
  }
  .messagelist {
    .el-table--enable-row-hover .el-table__body tr:hover>td{
      background-color:#fef3f3;
    }
  }
  .userForm{
    overflow: hidden;
    padding-top: 20px;
    .el-input__inner{
      width: 90%;
    }
    .el-select{
      width: 28%;
    }
    .addressxx{
      .el-input__inner{
        width: 100%;
      }
    }
    .el-form-item__label {
      text-align: left;
      padding-left: 20px;
    }
    button{
      float: right;
      margin-right: 75px;
    }
  }
  .addresslist{
    width: 90% !important;
    margin-left: 20px;
    border: 1px solid #ccc;
    .el-checkbox__inner{
      border-radius: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/address.vue